
import { postPoll } from '@geekbrains/geekbrains-ui-kit/src/elements/utils/api'

export default {
  name: 'QuestionnairesCard',

  props: {
    questionnaire: {
      type: Object,
      default: () => ({}),
      required: true
    },

    selectedTab: {
      type: String,
      default: 'new',
      required: true
    }
  },

  data() {
    return {
      i18n: 'pages.education.questionnaires'
    }
  },

  computed: {
    isFilled() {
      return this.selectedTab === 'filled'
    }
  },

  methods: {
    clickHandle() {
      if (this.questionnaire?.isNPS) {
        this.$store.commit('education/deleteNPSCard')
        this.$store.commit('notices/set', {
          type: 'isNPSCardClicked',
          payload: true
        })
      }
    },

    async deleteNPSCard() {
      this.$store.commit('education/deleteNPSCard')
      await postPoll('nps', {
        showedAt: new Date(),
        showType: null
      })
    }
  }
}
